import filterByText from "Common/componentUtils/filterByText";
import sort from "Common/componentUtils/sort";
import compact from "lodash/compact";
import forEach from "lodash/forEach";
import map from "lodash/map";
class SidebarMenuItem {
    constructor(key, title, icon, hash, sourceData, subItems) {
        this.getSubItemsKey = () => {
            let result = [];
            if (!this.subItems)
                return result;
            forEach(this.subItems, s => {
                result.push(s.key);
                result = result.concat(s.childKeys);
            });
            return result;
        };
        this.clone = () => {
            const result = new SidebarMenuItem(this.key, this.title, this.icon, this.hash, this.sourceData, this.subItems);
            result.className = this.className;
            result.useDotIcon = this.useDotIcon;
            result.iconDefaultWidth = this.iconDefaultWidth;
            result.subTitle = this.subTitle;
            result.onItemClick = this.onItemClick;
            result.actionElements = this.actionElements;
            result.draggableType = this.draggableType;
            result.draggableData = this.draggableData;
            result.isBtn = this.isBtn;
            result.opened = this.opened;
            result.active = this.active;
            result.selected = this.selected;
            return result;
        };
        this.sort = (sortBy, sortOrder) => {
            if (!sortBy || !this.subItems)
                return this;
            this.subItems = sort(this.subItems, sortBy, sortOrder);
            return this;
        };
        this.filterAndSort = (filterText, sortBy, sortOrder) => {
            if (!filterText || filterByText(filterText, this.title)) {
                return this.sort(sortBy, sortOrder);
            }
            if (!this.subItems)
                return undefined;
            const subItems = compact(map(this.subItems, s => (s ? s.filterAndSort(filterText, sortBy, sortOrder) : undefined)));
            if (!subItems.length)
                return undefined;
            const result = this.clone();
            result.subItems = subItems;
            return result;
        };
        this.key = key;
        this.title = title;
        this.icon = icon;
        this.hash = hash;
        this.sourceData = sourceData;
        this.subItems = subItems;
        this.childKeys = this.getSubItemsKey();
    }
}
export default SidebarMenuItem;
